<template>
  <div>
    <MarketResults :marketDate="$route.params.date" />
  </div>
</template>

<script>
import MarketResults from "../components/MarketResults";

export default {
  data() {
    return {};
  },
  components: {
    MarketResults
  },
  methods: {}
};
</script>

<style></style>
